var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"make-it"},[_c('vs-divider',{staticClass:"pb-0 mb-0"}),_c('vs-collapse',[_c('vs-collapse-item',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('SidebarTitle',{attrs:{"icon":"ZapIcon","title":_vm.title}})],1),_c('div',{staticClass:"cursor-default"},[_vm._t("default")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }